// extracted by mini-css-extract-plugin
module.exports = {"container":"ControlPanelContentDisplay_container__P4WrF","loading":"ControlPanelContentDisplay_loading__dFBGh"};